module.exports = __webpack_public_path__ + "img/shangjiantou.f80b58d8.png";